import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smartcare_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("smartcare_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

/**
 * Turn a backend-relative URL (e.g. "/api/photos/serve/xxx/full") into a fully
 * qualified URL that survives the `${REACT_APP_BACKEND_URL}/api` API_BASE join
 * WITHOUT double-prefixing "/api/api/". Absolute (http[s]://) URLs pass through.
 */
export function absolutiseApiUrl(u) {
  if (!u) return null;
  if (u.startsWith("http")) return u;
  const clean = u.startsWith("/api/") ? u.slice(4) : u;
  return `${API_BASE}${clean.startsWith("/") ? clean : "/" + clean}`;
}

export async function downloadBlob(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
